import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ConfigurationService } from '@nsk-app/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate{

  constructor(
    private router: Router,
    private config: ConfigurationService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const url = route.url.join('');

    if(url !== '/welcome' && this.config.hasDatabase == null){
      return this.router.parseUrl('/welcome');
    }

    return true;
  }

}
